/**
 * Financial Buckets — the high-level economic classification of project
 * spending, separate from (and above) Expense Categories.
 *
 * A category carries a DEFAULT bucket; an individual Actual Expense may
 * override it. The effective bucket is resolved by the financial engine:
 * expense override if present, otherwise the category default.
 *
 * These ids are stable internal identities (never display names).
 * The set is fixed by the product design; extending it is a deliberate
 * code + migration change, not user configuration.
 */
export type FinancialBucket =
  | "acquisition"
  | "renovation"
  | "holding"
  | "financing"
  | "selling"
  | "other";

export const FINANCIAL_BUCKETS: ReadonlyArray<{
  id: FinancialBucket;
  displayName: string;
}> = [
  { id: "acquisition", displayName: "Acquisition" },
  { id: "renovation", displayName: "Renovation" },
  { id: "holding", displayName: "Holding" },
  { id: "financing", displayName: "Financing" },
  { id: "selling", displayName: "Selling" },
  { id: "other", displayName: "Other" },
];

export function bucketDisplayName(id: FinancialBucket): string {
  return FINANCIAL_BUCKETS.find((b) => b.id === id)?.displayName ?? id;
}

export function isFinancialBucket(value: string): value is FinancialBucket {
  return FINANCIAL_BUCKETS.some((b) => b.id === value);
}
